var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "poll-wrapper" }, [
    _c("div", { staticClass: "poll-wrapper__element" }, [
      _c(
        "a",
        {
          staticClass: "poll-wrapper__close",
          attrs: { href: "" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v("×")]
      ),
      _c(
        "div",
        { staticClass: "poll-wrapper__content" },
        [
          _c(_vm.current, {
            tag: "component",
            on: {
              next: function($event) {
                return _vm.setData($event)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ed61c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ed61c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/Start.vue
// module id = 221
// module chunks = 4